import { render, staticRenderFns } from "./HelpDesk.vue?vue&type=template&id=205280bc&scoped=true"
import script from "./HelpDesk.vue?vue&type=script&lang=js"
export * from "./HelpDesk.vue?vue&type=script&lang=js"
import style0 from "./HelpDesk.vue?vue&type=style&index=0&id=205280bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205280bc",
  null
  
)

export default component.exports